import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../components/ui/accordion";

type SectionProperties = {
  title: string;
  defaultOpen?: boolean;
  children?: React.ReactNode;
};

function Section({ title, defaultOpen = true, children }: SectionProperties) {
  const value = title.toLowerCase().replaceAll(/\s+/g, "-");
  return (
    <Accordion
      type="single"
      collapsible
      defaultValue={defaultOpen ? value : undefined}
      className="border-border bg-card shrink-0 overflow-hidden rounded-lg border"
    >
      <AccordionItem value={value} className="border-b-0">
        <AccordionTrigger className="bg-section-header text-foreground px-2 py-2 text-base font-semibold hover:no-underline lg:px-4">
          {title}
        </AccordionTrigger>
        <AccordionContent className="text-muted-foreground px-2 pb-4 text-sm lg:px-4 lg:pb-6">
          {children ?? <p>TODO: implement {title} content.</p>}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export default Section;
